<template>


    <div class="page-content">   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>Ingreso datos OT {{ idcotizacionvehiculo }}</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	
     
		<div class="content-boxed">
			

  			<div class="content bottom-0">
				

				<div v-if="OT.TipoCliente == 3" data-height="110" class="caption caption-margins round-medium shadow-large">
					<div class="caption-bottom left-20 bottom-15">
						<h1 class="color-white bottom-0 bolder">{{ OT.nombre }}</h1>
					</div>
					<div class="caption-overlay bg-black opacity-75"></div>
					<div class="caption-bg bg-27"></div>
				</div>
				<div v-else data-height="110" class="caption caption-margins round-medium shadow-large">
					<div class="caption-bottom left-20 bottom-15">
						<h1 class="color-white bottom-0 bolder">{{ OT.nombre }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.paterno }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.materno }}</h1>
					</div>
					<div class="caption-overlay bg-black opacity-75"></div>
					<div class="caption-bg bg-27"></div>
				</div>   

 				<div class="caption caption-margins round-medium shadow-large">

					 <iframe class="caption caption-margins round-medium shadow-large" width="98%" height="600px" :src="getIframeSrc(idExterno)" frameborder="0"></iframe>

				</div>

				<div class="contact-form">
						<div class="content-boxed">
						<a href="#" @click="ImprimirOT(OT.idexterno)" class="icon icon-xs icon-circle bg-red2-dark" style="height:70px;width:70px"><i data-feather="printer" data-feather-line="1" data-feather-size="40" ></i><span class="color-red2-dark" style="position:relative;top:-20px">Imprimir</span></a>
						&nbsp;
						<a href="#" @click="VerOTInterna(OT.idexterno)" class="icon icon-xs icon-circle bg-red3-light" style="height:70px;width:70px;"><i data-feather="printer" data-feather-line="1" data-feather-size="40" ></i><span class="color-red1-light" style="position:relative;top:-20px">Cartón</span></a>
						&nbsp;
						<a href="#" data-menu="menu-email" class="icon icon-xs icon-circle bg-blue2-dark" style="height:70px;width:70px"><i data-feather="mail" data-feather-line="1" data-feather-size="40"></i><span class="color-blue2-dark" style="position:relative;top:-20px">Mail</span></a>
						&nbsp;
						<a href="#" data-menu="menu-whatsapp" class="icon icon-xs icon-circle bg-green2-dark" style="height:70px;width:70px"><i data-feather="message-circle" data-feather-line="1" data-feather-size="50"></i><span class="color-green2-dark" style="position:relative;top:-20px">Whatsapp</span></a>
						<br>
						<a href="#" class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="siguiente">Ingresar OT</a>
				</div>

                    <form onsubmit="event.preventDefault();" class="contactForm" id="Formsubmit" style="display:none">
                    </form>			
                </div>
            </div>


			<div id="sendingmail" class="shadow-large alert alert-large alert-round-medium bg-green1-dark" style="display:none">
                <i class="fa fa-check"></i>
                <strong class="uppercase ultrabold">Success</strong>
                <span>Everything's okay here</span>
                <i class="fa fa-times"></i>
            </div>  

			<div id="menu-email" class="menu menu-box-bottom menu-box-detached round-medium" data-menu-height="290" data-menu-effect="menu-over">
					<div id="menu-emailcontent" class="content">
						<h1 class="uppercase ultrabold top-20">Envío de OT por Email</h1>
						<form id="formemail">
							<span id="r_txtemail" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Requerido</span>
							<span id="e_txtemail" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">El formato de e-mail es incorrecto</span>
							<div class="input-style has-icon input-style-1 input-required">
								<span>Email</span>
								<em>(requerido)</em>
								<input id="txtemail" type="email" placeholder="Email" v-model="OT.email">
							</div>
			
							<div class="clear"></div>
							<a href="#" @click="enviarmail" class="button button-full button-s shadow-large button-round-small bg-blue2-dark top-10">Enviar e-mail</a>
							<div class="top-20 bottom-20">
								<a href="#" data-menu="salir" class="center-text font-11 color-gray2-dark">Para cancelar presione aquí</a>
							</div>
						</form>

					</div>

					<div id="sendingmail" class="shadow-large alert alert-large alert-round-medium bg-green1-dark" style="display:none">
						<i class="fa fa-check"></i>
						<strong class="uppercase ultrabold">Success</strong>
						<span>Everything's okay here</span>
						<i data-menu="salir" class="fa fa-times"></i>
					</div>  

			</div> 

			<div id="menu-whatsapp" class="menu menu-box-bottom menu-box-detached round-medium" data-menu-height="290" data-menu-effect="menu-over">
					<div class="content">
						<h1 class="uppercase ultrabold top-20">Envío de OT por Whatsapp</h1>
						<form id="formwhatsapp">
							<span id="r_txtfonowhatsapp" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Requerido</span>
							<div class="input-style has-icon input-style-1 input-required">
								<span>Teléfono</span>
								<em>(requerido)</em>
								<input id="txtfonowhatsapp" type="text" maxlength="11" placeholder="Teléfono" v-model="OT.fonowhatsapp">
							</div>
			
							<div class="clear"></div>
							<a href="#" @click="enviarwhatsapp" class="button button-full button-s shadow-large button-round-small bg-green2-dark top-10">Enviar Whatsapp</a>
							<div class="top-20 bottom-20">
								<a href="#" data-menu="salir" class="center-text font-11 color-gray2-dark">Para cancelar presione aquí</a>
							</div>
						</form>

					</div>

					<div id="sendingmail" class="shadow-large alert alert-large alert-round-medium bg-green1-dark" style="display:none">
						<i class="fa fa-check"></i>
						<strong class="uppercase ultrabold">Success</strong>
						<span>Everything's okay here</span>
						<i data-menu="salir" class="fa fa-times"></i>
					</div>  
			</div> 

    	</div>
		
    </div>


</template>

<style scoped>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image:url(./../../assets/images/firmacliente.png),
  linear-gradient(white, white),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-size:400px;
  background-origin: border-box;
  background-clip: content-box, border-box;
}

</style>


<script>

import * as db from "./../../database.js";
import * as validate from "./../../validate.js";
import pdf from 'vue-pdf'

export default {
	components: {
    	pdf
  	},
	data() {
      return {
		  params:'{"valkey":"'+localStorage.getItem('idcotizacionvehiculo')+'","tablename":"T_VEH_COTIZACIONVEHICULO"}',
		  idcotizacionvehiculo:0,
		  codusuario:0,
		  fecha:"",
		  sucursal:"" ,
		  idExterno: null,
		  idagenda:0,
		  idFile:Math.floor(Math.random() * 10000),
		  Direccioncliente:{},
		  OT:{}
	  }		

	},

	created(){
		this.idcotizacionvehiculo=localStorage.getItem('idcotizacionvehiculo');
		this.idagenda=localStorage.getItem('idagenda');
		this.userimageurl="background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")"  
		this.sucursal=JSON.parse(localStorage.getItem('user')).sucursal  
		this.fecha=localStorage.getItem('fechaagenda')  
		this.codusuario=JSON.parse(localStorage.getItem('user')).codusuario

	},

	mounted() {      

		let strSql;

		strSql="SELECT IN_KILOMETRAJEVEHICULO_COTIZACIONVEHICULO kilometraje,"
			+"DT_FECHAENTREGAOT_COTIZACIONVEHICULO fechaentregaot,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,120) fechaentrega,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,108) horaentrega,"
			+"COT.IN_ESORDENTRABAJOINTERNA_COTIZACIONVEHICULO datatipoot,"
			+"COT.IN_COD_TIPOTRABAJO datatipotrabajo,"
			+"CLI.ST_NOMBRE_CLIENTE nombre,"
			+"CLI.ST_APEPAT_CLIENTE paterno,"
			+"CLI.ST_APEMAT_CLIENTE materno,"
			+"CLI.ST_FONO1_CLIENTE fono1,"
			+"CLI.ST_FONO2_CLIENTE fono2,"
			+"'' fonowhatsapp,"
			+"CLI.ST_EMAIL_CLIENTE email,"
			+"ST_IDEXTERNO_COTIZACIONVEHICULO idexterno,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL1_VEHICULO) marca,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL2_VEHICULO) modelo,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL3_VEHICULO) version,"
			+"IN_AGNOFABRICACION_VEHICULO agno,ST_PLACAPATENTE_VEHICULO placapatente,ST_NVIN_VEHICULO vin,"
			+"CLI.IN_TIPO_CLIENTE TipoCliente"
			+" FROM T_VEH_COTIZACIONVEHICULO COT,T_VEH_VEHICULO V,T_CLI_CLIENTE CLI"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
			+" AND COT.IN_COD_VEHICULO=V.IN_COD_VEHICULO"
			+" AND COT.IN_COD_CLIENTE=CLI.IN_COD_CLIENTE"
		
		//id=5119734883644813930661942912&file=EmailOT12344
		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.OT=result.data.data
			this.idExterno = this.OT.idexterno;

			this.OT.fono1=this.OT.fono1.replace(/-/g,'\n')
			//this.OT.fonowhatsapp="+"

			this.OT.fonowhatsapp=this.OT.fono1
			if(this.OT.fono1!=null && this.OT.fono1.substring(0,3)!="569")
				this.OT.fonowhatsapp=""+this.OT.fono1

		}}); 
/*
		strSql="SELECT TOP 1 ST_DESC_DIRECCION direccion,ST_CASADPTO_DIRECCION casa,IN_NUMERO_DIRECCION numero,"
			+ "C1.ST_DESC_DETALLECLASIFICACION ciudad," 
			+ "C2.ST_DESC_DETALLECLASIFICACION comuna" 
			+" FROM T_VEH_COTIZACIONVEHICULO COT,T_CLI_CLIENTE CLI,T_GEN_DIRECCION D,T_GEN_DETALLECLASIFICACION C1,T_GEN_DETALLECLASIFICACION C2"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
			+" AND COT.IN_COD_CLIENTE=CLI.IN_COD_CLIENTE"
			+" AND D.IN_CODENTIDAD_DIRECCION=CLI.IN_COD_CLIENTE"
			+" AND (IN_ENTIDAD_DIRECCION=2 OR IN_ENTIDAD_DIRECCION=3)" 
			+" AND D.IN_VALORNIVEL1REGIONCOMUNA_DIRECCION=C1.IN_COD_DETALLECLASIFICACION"
			+" AND D.IN_VALORNIVEL2REGIONCOMUNA_DIRECCION=C2.IN_COD_DETALLECLASIFICACION"

		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.Direccioncliente=result.data.data
		}}); 
*/
},


	methods: {

		siguiente()
		{
			
		db.getFx("ot.ingresarot",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","codasesor":"'+this.codusuario+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			window.location="/OTAgenda"
		}});

		},
		enviarmail(){
			var strErr=validate.check(formemail)
			if (strErr==""){
				db.getFx("ot.observacion",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","motivo":"Envío email Orden trabajo","obs":"'+ document.getElementById("txtemail").value +'","codasesor":"'+this.codusuario+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
					db.getFx("ot.sendmail",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","codasesor":"'+this.codusuario+'","idfileemail":"'+ this.idFile+'","emailcliente":"'+ document.getElementById("txtemail").value +'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
						window.location="/Wizardot7printemail"
					}});
				}});
			}

		},
		enviarwhatsapp(){
			var strErr=validate.check(formwhatsapp)
			
			let urlBDD = db.getServerHTTP()

			let url = "";

			// Comprobar y reemplazar la URL si es necesario
			if (urlBDD.startsWith("https://puente.xxi.cl/")) {

				url = "https://preproduccionxxi.netcar.cl/otprocess.aspx?id=" + this.idagenda;
			}

			if (urlBDD.startsWith("https://puente.valenzueladelarze.cl/")) {
				url = "https://vyd.netcar.cl/otprocess.aspx?id=" + this.idagenda;
			}

			var txtTexto="Revise el estado de su Orden de Trabajo en este link: "+url

			if (strErr==""){
				db.getFx("ot.observacion",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","motivo":"Envío whatsapp Orden trabajo","obs":"'+ document.getElementById("txtfonowhatsapp").value +'","codasesor":"'+this.codusuario+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
					db.getFx("ot.sendwhatsapp",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","codasesor":"'+this.codusuario+'","fono":"'+ document.getElementById("txtfonowhatsapp").value +'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
						window.open("https://api.whatsapp.com/send?phone="+document.getElementById("txtfonowhatsapp").value+"&text="+txtTexto, "_blank");
						window.location="/Wizardot7printemail"
					}});
				}});
			}
		},
		//'"+db.getServerHTTP()+"/taller/tlrShowOTInterna.aspx?id='+ST_IDEXTERNO_COTIZACIONVEHICULO+'&file="+this.idFile+"'
		VerPDFOT(id){

			var url =db.getServerHTTP();

			if(url == "https://puente.xxi.cl/"){
				url = "https://xxi.netcar.cl";
			}

			if(url == "https://puente.valenzueladelarze.cl/"){
				url = "https://vyd.netcar.cl";
			}

			window.open(url+"/taller/tlrShowOTInterna.aspx?id="+id+"&file="+this.idFile+"'", "_blank");
		},

		VerOTInterna(id){

			let url = db.getServerHTTP()+"/taller/tlrShowOTInterna.aspx?id="+id+"&file="+this.idFile+"'";
			
			// Comprobar y reemplazar la URL si es necesario
			if (url.startsWith("https://puente.xxi.cl/")) {
				url = url.replace("https://puente.xxi.cl/", "https://xxi.netcar.cl/");
			}

			if (url.startsWith("https://puente.valenzueladelarze.cl/")) {
				url = url.replace("https://puente.valenzueladelarze.cl/", "https://netcar3.valdelarze.cl/");
			}

			if (url.startsWith("https://preproduccionxxi.netcar.cl/")){
				url = db.getServerHTTP() + "resources/_netcarsiglo21com/taller/tlrShowOTInterna.aspx?id=" + id + "&file="+this.idFile+"'";
			}

			window.open(url, "_blank");
		},
	
		ImprimirOT(id){
			let url = db.getServerHTTP()+"/taller/tlrShowOT.aspx?id="+id+"&file="+this.idFile+"'";

			// Comprobar y reemplazar la URL si es necesario
			if (url.startsWith("https://puente.xxi.cl/")) {
				url = url.replace("https://puente.xxi.cl/", "https://xxi.netcar.cl/");
			}

			if (url.startsWith("https://puente.valenzueladelarze.cl/")) {
				url = url.replace("https://puente.valenzueladelarze.cl/", "https://netcar3.valdelarze.cl/");
			}

			if (url.startsWith("https://preproduccionxxi.netcar.cl/")){
				url = db.getServerHTTP() + "resources/_netcarsiglo21com/taller/tlrShowOT.aspx?id=" + id + "&file="+this.idFile+"'";
			}

			window.open(url, "_blank");
		},
		getIframeSrc(id) {
			// return db.getServerHTTP() + '/taller/tlrShowOT2.aspx?id=' + id;

			let url = db.getServerHTTP() + '/taller/tlrShowOT.aspx?id=' + id;

			if (url.startsWith("https://puente.valenzueladelarze.cl/")) {
				url = url.replace("https://puente.valenzueladelarze.cl/", "https://netcar3.valdelarze.cl/");
			}

			if (url.startsWith("http://qa.netcarportillosur.com/")){
				url = db.getServerHTTP() + 'resources/_QaPortilloSur/taller/tlrShowOT.aspx?id=' + id;
			}

			if (url.startsWith("https://preproduccionxxi.netcar.cl/")){
				url = db.getServerHTTP() + 'resources/_netcarsiglo21com/taller/tlrShowOT.aspx?id=' + id;
			}

			if (url.startsWith("https://puente.xxi.cl/")) {
				url = 'https://preproduccionxxi.netcar.cl/resources/_netcarsiglo21com/taller/tlrShowOT.aspx?id=' + id;
			}

			return url;

		},


	}
}

</script>
